import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { StateService } from '@uirouter/angular';
import { FrontEndService } from '../../services/front-end.service';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {
  @Input() current_state = '';
  showcount = 0;
  unreadCount = 0;
  notificationCount = 0;

  constructor (
    public dataService: DataService,
    private stateService: StateService,
    private frontEndService: FrontEndService,
    private apiService: ApiService
  ) {}
  ngOnInit() {
    this.dataService.userDetails = JSON.parse(localStorage.getItem('user'));
    // this.logService.printLog("getItem for local storage -" ,this.dataService.userDetails)
    this.getUnreadTransaction();
    setInterval(() => {
      this.getUnreadTransaction();
      // this.logService.printLog("test timmer");
    }, 5000)
    if(this.dataService.userDetails.hasOwnProperty("profile")) {
      if(this.current_state !== "profile" && !this.dataService.userDetails['profile']["emailVerified"]) {
        this.stateService.go('profile');
      }
    }

  }

  logOut() {
    this.dataService.clearData();
    this.stateService.go('landing');
  }

  profile() {
    this.stateService.go('profile');
  }

  toggleSidebar() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle('push-right');
  }

  getUnreadTransaction() {
    const user_id = {'user_id': this.dataService.userDetails['user_id']};
    this.apiService.notifications(user_id, (response) => {
      this.showcount = response["unreadTransaction"];
      this.notificationCount = response['notifications'].length;
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/app-header/app-header.component.ts